export default __webpack_public_path__ + "static/media/linen.b01091a5.webp";